import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { userOption, userResult } from '../../models/orders/order-list-model';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import orderServices from '../../services/orders/orderservice';
import '../../assests/css/common/responsive-ui.css'


interface SearchPanelProps {
  onSearch: (query: number) => void;
  onLocalFilter: (keyword: string) => void;
  addressCount: number;
  onAddClick: (uid: number) => void;
  setLoading: (loading: boolean) => void;
  onReset : () => void;
}

const EditAddressSearch: React.FC<SearchPanelProps> = ({ onSearch, onLocalFilter,addressCount, onAddClick, setLoading, onReset }) => {

    const { t } = useTranslation();
    const [selectedUser, setSelectedUser] = useState<any>();
    const [searchKeyword, setSearchKeyword] = useState("");
    const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: ''},];
    const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
    const [orderUser, setOrderUser] = useState<userResult[]>([]);
    
    useEffect(() => {              
        if (orderUsers.length > 0) {
            setOrderUser(orderUsers.map((user) => ({
                userID: user.userID,
                detail: user.userID !== 0 ? `${user.name}, ${user.primaryContactNbr}` : "",
            })));
        }
    }, [orderUsers]);    

    const handleDropdownChange = (e: DropdownChangeEvent) => {
        setSelectedUser(e.value);
    }    

    const handleDropdownFilter = (e: DropdownFilterEvent) => {
        if(e.filter.length>2){
            orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
                if(response.length>0){
                    setOrderUsers(response)
                }        
            })
        }
    }

    const handleSearch = () => {
        setLoading(true); 
        let searchFilter: number = selectedUser;
        // if(selectedUser) {
        //     searchFilter = searchFilter + " and userID eq " + selectedUser;
        // }       
        onSearch(searchFilter); 
    }
    console.log("selected user", selectedUser);

    const handleAddClick = () => {
        onAddClick(selectedUser);
    }

    const resetSearchFields = () => {
        setOrderUsers(blankUserDetail);
        setSelectedUser(null);
        setSearchKeyword(""); 
        onLocalFilter("");     
        onReset();
    }

    return (
        <div className="col-12">
            <div className="card border-noround p-2" style={{ minHeight: '3.5rem'}}>
                <div className="input-container font-bold text-white border-round" style={{ float: "left", width: "18%" }}>
                    <div className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText type='search' onChange={(e) => {onLocalFilter(e.target.value); setSearchKeyword(e.target.value);}} placeholder="Keyword Search" style={{ width: "100%" }} value={searchKeyword}/>
                    </div>
                </div>
                <div className="dropdown-search font-bold text-white border-round " style={{ float: "left", width: "20%" }}>
                    <Dropdown
                        id="SearchUser"
                        name="SearchUser"                                                      
                        options={orderUser} 
                        optionLabel="detail"
                        optionValue="userID"
                        value={selectedUser}
                        onChange={handleDropdownChange}
                        onFilter={handleDropdownFilter} filter
                        placeholder="Search for User/Mobile" style={{ width: "100%" }}
                    />
                </div>
                <div className="buttons-container">
                <div className="filter-button font-bold text-white border-round " style={{ float: "left", textAlign:'right', width: "10%" }}>
                    <Button className=" text-black border-round" style={{ width: "100%", textAlign:'center' }} onClick={handleSearch} severity="success">Filter</Button>
                </div>
                <div className="filter-button font-bold text-white border-round ml-2" style={{ float: "left", textAlign:'right', width: "10%" }}>
                    <Button className="text-black border-round" style={{ width: "100%", textAlign:'center' }} onClick={resetSearchFields} severity="secondary" text raised>Reset</Button>
                </div>
                {addressCount===0 && <div className="add-button-container border-round font-bold ml-3 text-primary" style={{textAlign:'right'}}>
                    <Button className="bg-blue-700 border-round p-button p-button-text p-component text-center text-white" style={{textAlign:'center' }} onClick={handleAddClick} severity="secondary" text raised>Add Address</Button>
                </div>}
                </div>
            </div>
        </div>
    );
};
export default EditAddressSearch;
